import React from "react";
import styles from "./PlaceholderCard.module.css";
import finishedIcon from "../../../assets/icons/finishedIcon.svg";
import HomeCard from "./HomeCard";

type PlaceholderCardProps = {
    title?: string;
    message?: string;
    iconSrc?: string;
    showIcon?: boolean;
};

const PlaceholderCard: React.FC<PlaceholderCardProps> = ({
    message = "There’s nothing more to review right now. You can check back later or revisit earlier items.",
    iconSrc = finishedIcon,
    showIcon = true,
}) => {
    return (
        <HomeCard>
            <div className={styles.placeHolderContentContainer}>
                {showIcon && (
                    <div className={styles.iconContainer}>
                        <div className={styles.iconBackground}>
                            <img src={iconSrc} className={styles.icon} alt="finished" />
                        </div>
                    </div>
                )}
                <div className={styles.textBlock}>
                    {message}
                </div>
            </div>
        </HomeCard>
    );
};

export default PlaceholderCard;
